angular.module('mercury', [
/*Vendor Dependencies*/
'ui.bootstrap',
'ui.router',
'LocalStorageModule',
'ngResource',
'ngToast',
'ngSanitize',
'textAngular',
'flow',
'ngJcrop',
'ngMessages',
'as.sortable',
/*App Modules*/
'mercury.constants',
'mercury.dialogs',
'mercury.layouts',
'mercury.directives',
'mercury.filters',
'mercury.services',
'mercury.startup',
'mercury.modules.budget',
'mercury.modules.cashup',
'mercury.modules.error',
'mercury.modules.qa',
'mercury.modules.reports',
'mercury.modules.settings',
'mercury.modules.stock',
'mercury.modules.thirdparty',
'mercury.modules.time',
'mercury.modules.placeholders'
]);
